import { createRoute } from '@tanstack/react-router';
import { OrderDetailPage } from '@/features/orders/order-detail-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/commandes/$id` — Détail d'une commande (`02` §4). Route fille de
 * `_authenticated`, sœur de `ordersRoute` (`commandes.tsx`) plutôt que sa
 * fille : elle a son propre contenu de page complet, pas un `Outlet` de
 * liste. Volontairement absente de `components/layout/nav-config.ts` (sous-
 * écran sans entrée de menu, `README-shell.md`) et sans
 * `staticData.showStoreSelector` (une commande a déjà sa boutique dans l'en-
 * tête, pas besoin du sélecteur global).
 *
 * **Câblage central (hors périmètre de cette vague)** : à ajouter dans
 * `authenticatedRoute.addChildren([...])` de `src/router.tsx`, aux côtés de
 * `ordersRoute`.
 */
export const orderDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/commandes/$id',
  component: OrderDetailPage,
});
